import React, { useMemo, useState } from 'react';
import './SelectorChips.css';

const CheckIcon = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

function SelectorChips({
  label, items = [], selectedIds = [],
  onToggle, onSelectAll, onClearAll,
  loading = false, emptyHint = 'Nothing to show',
}) {
  const [query, setQuery] = useState('');
  const selected = useMemo(() => new Set(selectedIds), [selectedIds]);
  const anySelected = selectedIds.length > 0;

  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((i) => i.name.toLowerCase().includes(q));
  }, [items, query]);

  return (
    <div className="sc-group">
      <div className="sc-head">
        <div className="sc-overline">
          {label} <span className="sc-count">· <b>{selectedIds.length}</b> of {items.length} selected</span>
        </div>
        <div className="sc-tools">
          <div className="sc-search">
            <SearchIcon />
            <input
              type="text"
              placeholder={`Filter ${label.toLowerCase()}`}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <button
            type="button"
            className="sc-link"
            onClick={anySelected ? onClearAll : onSelectAll}
            disabled={loading || items.length === 0}
          >
            {anySelected ? 'Clear all' : 'Select all'}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="sc-loading">Loading…</div>
      ) : items.length === 0 ? (
        <div className="sc-empty">{emptyHint}</div>
      ) : (
        <div className="sc-chips">
          {visible.map((item) => {
            const on = selected.has(item.id);
            return (
              <button
                key={item.id}
                type="button"
                className="sc-chip"
                aria-pressed={on}
                onClick={() => onToggle(item.id)}
              >
                <span className="sc-tick"><CheckIcon /></span>
                {item.dotColor && (
                  <span className="sc-dot" style={{ background: item.dotColor }} />
                )}
                <span className="sc-name">{item.name}</span>
                {item.meta != null && <span className="sc-meta">{item.meta}</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SelectorChips;
